import React, { useState } from 'react';

import './CookiesStrip.css';

const CookiesStrip = () => {
  const [showCookiesPolicy, setShowCookiesPolicy] = useState<boolean>(false);
  const [showCookiesMessage, setShowCookiesMessage] = useState<boolean>(false);

  const handleMouseEnter = () => {
    setShowCookiesPolicy(true);
  };

  const handleMouseExit = () => {
    setShowCookiesPolicy(false);
  };

  const handleClickCookiesPolicy = () => {
    setShowCookiesMessage(true);
  };

  const handleDeclineCookies = () => {
    setShowCookiesPolicy(false);
    setShowCookiesMessage(false);
  };

  const handleAllowCookies = () => {
    setShowCookiesPolicy(false);
    setShowCookiesMessage(false);
  };

  return (
    <div className='cookie-policy-container'>
      <button
        className='fingerprint-icon'
        style={{
          backgroundColor: '#001f3d',
          width: 50,
          height: 50,
        }}
        onClick={handleClickCookiesPolicy}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseExit}
      >
        <img
          src='/assets/icons-fingerprint.png'
          alt='fingerprint'
          className='fingerprint-img'
        />
      </button>

      {showCookiesPolicy && !showCookiesMessage && (
        <button
          className='cookies-policy-button'
          onClick={handleClickCookiesPolicy}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseExit}
        >
          Cookies Policy
        </button>
      )}

      {showCookiesMessage && (
        <div className='cookies-policy-message'>
          <div
            style={{
              color: 'white',
              fontWeight: 500,
              fontSize: 16,
              marginLeft: 10,
              paddingTop: 15,
            }}
          >
            We use cookies and other tracking technologies to personalise and
            improve your experience. By continuing to use our website, you
            consent to this.
          </div>
          <div className='cookies-buttons'>
            <button
              className='cookie-button decline'
              onClick={handleDeclineCookies}
            >
              Decline
            </button>
            <button
              className='cookie-button allow'
              style={{
                backgroundColor: 'rgb(128, 31, 9)',
                height: 30,
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 20,
                marginTop: 10,
                borderRadius: 8,
              }}
              onClick={handleAllowCookies}
            >
              Allow Cookies
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookiesStrip;
